import { render } from "./DialogError.vue?vue&type=template&id=4dfd1e48"
import script from "./DialogError.vue?vue&type=script&lang=js"
export * from "./DialogError.vue?vue&type=script&lang=js"
script.render = render

export default script